export interface LegalReference {
    code: string;
    title: string;
    subtitle?: string;
    url?: string;
    version?: string;
  }
  
  export const LEGAL_CARDIHAB: LegalReference[] = [
    {
      code: 'aboutCardihab',
      title: 'About Cardihab',
      version: '1',
      url: 'https://cardihab.com'
    },
    {
      code: 'termsAndConditionsCardihab',
      title: 'Terms and Conditions',
      version: '1',
      url: 'https://cardihab.com/terms'
    },
    {
      code: 'privacyStatementCardihab',
      title: 'Privacy Statement',
      version: '1',
      url: 'https://cardihab.com/privacy'
    },
    {
      code: 'acknowledgements',
      title: 'Acknowledgements',
      version: '1',
      url: 'https://cardihab.com/acknowledgements'
    }
  ];
  
  export const LEGAL_QCG: LegalReference[] = [
    {
      code: 'aboutQCG',
      title: 'About QCG',
      version: '1',
      url: 'https://www.qcg.com.au/rehab'
    },
    {
      code: 'termsAndConditionsQCG',
      title: 'Terms and Conditions',
      version: '1',
      url: 'https://qcg.com.au/terms-and-conditions'
    },
    {
      code: 'privacyStatementQCG',
      title: 'Privacy Statement',
      version: '1',
      url: 'https://qcg.com.au/patient-privacy'
    },
    {
      code: 'acknowledgements',
      title: 'Acknowledgements',
      version: '1',
      url: 'https://cardihab.com/acknowledgements'
    }
  ];
  
  export const LEGAL_MEDIBANK: LegalReference[] = [
    {
      code: 'aboutMedibank',
      title: 'About Medibank',
      version: '1',
      url: 'https://www.medibank.com.au/'
    },
    {
      code: 'termsAndConditionsMedibank',
      title: 'Terms and Conditions',
      version: '1',
      url: 'https://cardihab.com/terms/'
    },
    {
      code: 'privacyStatementMedibank',
      title: 'Privacy Statement',
      version: '1',
      url: 'https://cardihab.com/privacy/'
    },
    {
      code: 'acknowledgements',
      title: 'Acknowledgements',
      version: '1',
      url: 'https://cardihab.com/acknowledgements'
    }
  ];
  
  export const LEGAL_RFDS: LegalReference[] = [
    {
      code: 'aboutRfds',
      title: 'About Us',
      version: '1',
      url: 'https://www.flyingdoctor.org.au/tas/about/'
    },
    {
      code: 'supportUs',
      title: 'Support Us',
      version: '1',
      url: 'https://www.flyingdoctor.org.au/tas/support-us/'
    },
    {
      code: 'termsAndConditionsMedibank',
      title: 'Terms and Conditions',
      version: '1',
      url: 'https://cardihab.com/terms/'
    },
    {
      code: 'privacyStatementRfds',
      title: 'Privacy Statement',
      version: '1',
      url: 'https://cardihab.com/privacy/'
    },
    {
      code: 'acknowledgements',
      title: 'Acknowledgements',
      version: '1',
      url: 'https://cardihab.com/acknowledgements'
    }
  ];
  